import React, { useState } from 'react'
import Modal from 'react-bootstrap-modal'
import FlashAlert from '../../../components/flash-alert'
import { ajaxPatch } from '../../../ajax'

export default function ChangeTeam({league, player, teams, onClose, onUpdate}) {
  const [alert, setAlert] = useState()
  const [selectedTeam, setSelectedTeam] = useState(player.team_id)
  const [loading, setLoading] = useState(false)

  const onSave = async () => {
    if (selectedTeam == player.team_id) return onClose()

    setLoading(true)
    const data = { member: { team_id: selectedTeam } }
    
    const response = await ajaxPatch(`/admins/leagues/${league.id}/members/${player.id}.json`, data)
    const json = await response.json()
    setLoading(false)
    if (json.alert) setAlert(json.alert)
    else onUpdate(json.member)
  }

  const imageUrl = (team) => {
    if (!team.photo) return '/images/leagues/team.png'

    return team.photo + '?' + Math.random()
  }

  return <Modal container={document.body} backdrop='static' show={true} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>Add/Change Team</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className={'change-team-form' + (loading ? ' isLoading' : '')}>
        { loading && <div className='animated-spinner'></div> }
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        <div className='member-name'>{player.name}</div>
        <label className='member-label'>
          Choose Team
          <div className='member-teams-wrapper'>
            <div className='member-teams'>
              { teams.map((team, i) => {
                const checked = team.id == selectedTeam
                return <div key={i} className={'member-team' + (checked ? ' checked' : '')} onClick={() => setSelectedTeam(team.id)}>
                  <div className='team-title'>
                    <img src={imageUrl(team)} />
                    <span>{team.name}</span>
                  </div>
                  { checked && <div className='team-checked'></div> }
                </div>
              })}
            </div>
          </div>
        </label>
        <div className='member-buttons'>
          <button className='member-button button-back' onClick={onClose}>Cancel</button>
          <button className='member-button button-save' onClick={onSave}>Save</button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
}
